import { ArrowRight, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";

const HERO_IMAGE =
  "https://images.pexels.com/photos/28827841/pexels-photo-28827841.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen flex items-end overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="Empty stadium at night"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/40 to-[#0a0a0a]" />
        <div className="absolute inset-0 bg-black/30" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 pb-20 pt-40 lg:pt-44 lg:pb-32">
        <div className="flex items-center gap-3 mb-8 fade-up">
          <span className="h-px w-12 bg-red-600" />
          <span className="text-xs uppercase tracking-[0.3em] text-red-600">
            Witbank · Mpumalanga · Est. 2022
          </span>
        </div>

        <h1
          data-testid="hero-title"
          className="font-heading uppercase font-bold leading-[0.85] tracking-tight text-white text-6xl sm:text-7xl lg:text-[8rem] xl:text-[10rem] fade-up"
          style={{ textShadow: "0 4px 32px rgba(0,0,0,0.6)" }}
        >
          Giving <span className="text-red-600">Talent</span>
          <br />
          A Platform.
        </h1>

        <div className="mt-10 max-w-2xl fade-up">
          <p className="text-base sm:text-lg text-white/80 leading-relaxed">
            A youth soccer academy in the heart of Witbank, building the next
            generation of South African footballers — one disciplined session at
            a time.
          </p>
        </div>

        <div className="mt-12 flex flex-col sm:flex-row gap-4 fade-up">
          <Button
            asChild
            data-testid="hero-register-button"
            size="lg"
            className="bg-red-600 hover:bg-red-500 text-white font-heading uppercase tracking-widest rounded-full px-8 h-14 text-sm"
          >
            <a href="#register" className="inline-flex items-center gap-2">
              Enroll Your Player <ArrowRight className="h-4 w-4" />
            </a>
          </Button>

          <Button
            asChild
            data-testid="hero-programs-button"
            size="lg"
            variant="outline"
            className="bg-transparent border-white/30 text-white hover:bg-white/10 hover:text-red-600 font-heading uppercase tracking-widest rounded-full px-8 h-14 text-sm"
          >
            <a href="#programs">View Programs</a>
          </Button>
        </div>

        <div className="mt-16 inline-flex items-center gap-2 text-xs uppercase tracking-widest text-white/50 fade-up">
          <MapPin className="h-3.5 w-3.5 text-red-600" />
          Witbank, eMalahleni · Mpumalanga
        </div>
      </div>
    </section>
  );
}
